import { render, staticRenderFns } from "./InformasiUmum.vue?vue&type=template&id=f5baa1e6&scoped=true&"
import script from "./InformasiUmum.vue?vue&type=script&lang=js&"
export * from "./InformasiUmum.vue?vue&type=script&lang=js&"
import style0 from "./InformasiUmum.vue?vue&type=style&index=0&id=f5baa1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5baa1e6",
  null
  
)

export default component.exports